"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageWorldState = exports.sendMessageAndImmediatelyExecute = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = void 0;
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var voyageMessageIds_1 = require("./voyageMessageIds");
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.LoadShip;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.writeString(m, d.filename);
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        filename: messageWriter_sidecar_1.messageWriter.readString(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        filename: 'testship_123',
    };
    messageWriter_sidecar_1.messageWriter.test('load-ship', ex, write, read);
}
exports.test = test;
function process(m) {
    var msg = read(m);
    // TODO:
    // Load ship, set loading generator
    // After loading generator done, request rest of ship
}
exports.process = process;
function sendMessageAndImmediatelyExecute(msg) {
    websockets_sidecar_1.websockets._sendMessageAndImmediatelyExecute(write, msg);
}
exports.sendMessageAndImmediatelyExecute = sendMessageAndImmediatelyExecute;
function sendMessageWorldState(msg, multiId) {
    websockets_sidecar_1.websockets._sendMessageWorldState(write, msg, multiId);
}
exports.sendMessageWorldState = sendMessageWorldState;
